import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en/translation.json";
import ruTranslation from "./locales/ru/translation.json";
import ukTranslation from "./locales/uk/translation.json";

export const LANG_KEY = "LANG_KEY";
const SUPPORTED_LANGUAGES = new Set(["en", "ru", "uk"]);

const normalizeLanguage = (language) => {
  if (language === "ua") return "uk";
  return SUPPORTED_LANGUAGES.has(language) ? language : undefined;
};

const readProfileLanguage = () => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    return normalizeLanguage(auth?.user?.language);
  } catch {
    return undefined;
  }
};

const language =
  readProfileLanguage() ||
  normalizeLanguage(localStorage.getItem(LANG_KEY)) ||
  "en";

localStorage.setItem(LANG_KEY, language);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ru: { translation: ruTranslation },
      uk: { translation: ukTranslation },
    },
    lng: language,
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
  });

document.documentElement.lang = language;
i18n.on("languageChanged", (nextLanguage) => {
  document.documentElement.lang = nextLanguage;
});

export default i18n;
